import ReactDOM from 'react-dom/client';
import { v2Component } from '../../index';
import { TenantContext } from '../../context/tenant-context';
import { ProductUnitsList } from './product-units-list';
import { ToastContainer } from 'react-toastify';

export function initProductUnitsList() {
  document.getElementsByName('product-units-list').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductUnitsList />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
